/**
 * @generated SignedSource<<dbaffba8737390f0dc900708ae267e6a>>
 * @relayHash d79da193554037b8c219ac88b7fb1a04
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d79da193554037b8c219ac88b7fb1a04

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommenceGradingInput = {
  clientMutationId?: string | null;
  examId: string;
};
export type adminCommenceGradingMutation$variables = {
  input: CommenceGradingInput;
};
export type adminCommenceGradingMutation$data = {
  readonly commenceGrading: {
    readonly success: boolean;
  } | null;
};
export type adminCommenceGradingMutation = {
  response: adminCommenceGradingMutation$data;
  variables: adminCommenceGradingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CommenceGradingPayload",
    "kind": "LinkedField",
    "name": "commenceGrading",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "adminCommenceGradingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "adminCommenceGradingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "d79da193554037b8c219ac88b7fb1a04",
    "metadata": {},
    "name": "adminCommenceGradingMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b4fa44075bf449dad05e66b6922f88ba";

export default node;
